import { useRouter } from 'next/router'
import { useEffect, useRef, useState } from 'react'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules'

export function useOpenNotificationMenuQuery({ allowCheck }: { allowCheck: boolean }) {
  const { query, replace } = useRouter()
  const { revalidateModules } = useRevalidateModules()
  const isUsedOnce = useRef(false)
  const [openThroughQuery, setOpenThroughQuery] = useState(false)

  useEffect(() => {
    if (!allowCheck) return

    const { [useOpenNotificationMenuQuery.queryToOpenNotificationMenu]: targetedQuery, ...rest } =
      query

    if (targetedQuery !== undefined && !isUsedOnce.current) {
      setOpenThroughQuery(true)
      replace({ query: rest }, undefined, { shallow: true })
      isUsedOnce.current = true
    }
  }, [query, allowCheck])

  useEffect(() => {
    if (openThroughQuery) {
      revalidateModules([RequestModuleEnum.Notifications], true)
    }
  }, [openThroughQuery])

  return { openThroughQuery, setOpenThroughQuery }
}

useOpenNotificationMenuQuery.queryToOpenNotificationMenu = 'open-notification-center'
